
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-store-3-line',
      title: '美容・ネイルサロン向けLP',
      description: '沖縄の美容業界に特化したデザインとコンテンツで、地域のお客様に愛されるサロンサイトを制作します。',
      features: ['予約システム連携', 'ビフォーアフター画像', 'スタッフ紹介', 'メニュー・料金表']
    },
    {
      icon: 'ri-cup-line',
      title: 'カフェ・飲食店LP',
      description: '沖縄の食文化と融合した魅力的なカフェLP。観光客と地元客両方にアピールできるデザインを提供。',
      features: ['メニュー表示', 'アクセス情報', 'イベント告知', 'SNS連携']
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'エステ・マッサージサロンLP',
      description: 'リラクゼーション業界向けの癒しと信頼感を演出するLP設計。沖縄らしい自然な雰囲気を大切にします。',
      features: ['施術メニュー', 'セラピスト紹介', 'お客様の声', '予約フォーム']
    },
    {
      icon: 'ri-briefcase-line',
      title: 'コンサル・士業向けLP',
      description: '専門性と信頼性を重視したプロフェッショナルLP。沖縄のビジネス環境に精通した内容で差別化を図ります。',
      features: ['サービス紹介', '実績・事例', 'プロフィール', 'お問い合わせ']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>沖縄起業</strong>に特化したLP制作サービス
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            現地視点で、沖縄の市場ニーズに合わせたLP・ホームページを制作いたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-teal-500 rounded-full flex items-center justify-center mr-4">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900">{service.title}</h4>
              </div>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              <div className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
